import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Customer } from '@models/customer';
import { SelectEntitiesService } from '@services/entity/select-entities.service';
import { CustomersService } from '@services/entity/customers.service';
import { plainToClass } from 'class-transformer';
import { TableColumn } from '@models/tableColumn';
import { IEntity } from '@interfaces/entity';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { TableComponent } from '@components/abstract/table/table.component';
import { OperatorsService } from '@services/entity/operators.service';
import { UsersService } from '@services/entity/users.service';
import { Operator } from '@models/operator';
import { CustomersTableEntry } from '@dto/customersTableEntry';
import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import '@angular/localize/init';
import { TableOptions } from '@models/tableOptions';
import { PricingsService } from '@services/entity/pricings.service';
import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'app-customers-table',
  templateUrl: './customers-table.component.html'
})
export class CustomersTableComponent extends AbstractEntitiesTableComponent implements OnInit, OnDestroy {

  public className = 'CustomersTableComponent';

  private operator: Operator;
  public entities: CustomersTableEntry[];
  public isOperatorView: boolean;
  public isSupporter: boolean;
  public activeComponentClassName: string = 'CustomersTableComponent';
  public isTestingOrDevStage: boolean = false;


  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@CustomersTableColumn1:Kunden-Nr.`, property: 'customerId' },
    { columnDescription: $localize`:@@CustomersTableColumn5:Firma`, property: 'company' },
    { columnDescription: $localize`:@@CustomersTableColumn6:Bezeichner`, property: 'internalDescription' },
    { columnDescription: $localize`:@@CustomersTableColumn3:Ansprechpartner`, property: 'fullName' },
    { columnDescription: $localize`:@@CustomersTableColumn2:E-Mail`, property: 'email' },
    { columnDescription: $localize`:@@CustomersTableColumn4:Telefonnummer`, property: 'phone' },
    { columnDescription: $localize`:@@CustomersTableColumn4:Ladestationen`, property: 'chargingStations' },
    { columnDescription: $localize`:@@CustomersTableColumn4:Energiemonitor`, property: 'blackBox' },
    { columnDescription: $localize`:@@CustomersTableColumn4:Benutzer`, property: 'users' },
  ];

  public tableOptions: TableOptions = { hideActions: true, rowRouterLink: '/customer/{id}' };

  private sortParam: number;


  constructor(
    public customersService: CustomersService,
    private operatorsService: OperatorsService,
    private usersService: UsersService,
    public pricingsService: PricingsService,
    private toastService: ToastService,
    injector: Injector) {
      super(customersService, injector);
  }

  ngOnInit() {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    this.isSupporter = this.authenticationService.userHasRole('Supporter');
    this.isTestingOrDevStage = (window.location.host == 'cubos-connect-testing.azurewebsites.net') || (window.location.host == 'cubos-connect-dev.azurewebsites.net') || (window.location.host == 'localhost:44304')
    super.ngOnInit();

    this.activatedRoute.queryParams.subscribe(params => {
      this.sortParam = params.sort;
    });

    if (!this.sortParam) {
      this.tableFunctions.sortColumn = 'customerId';
      this.tableFunctions.sortDirection = 'desc';
    }
  }

  initializeEntities() {
    this.usersService.getOperatorOfUser(this.usersService.getCurrentUserId()).subscribe(result => {
      this.operator = plainToClass(Operator, result);
      this.operatorsService.getCustomersTableOfOperator(this.operator.id).subscribe(result => {
        this.entities = result;
        this.sortEntities();
        super.setupTable();
      })
    })
  }

  sortEntities() {
    if (this.sortParam) {
      var entitiesWithSortParam = this.entities.filter(x => x.customerId == this.sortParam);
      var entitiesWithoutSortParam = this.entities.filter(x => x.customerId != this.sortParam);

      this.entities = entitiesWithSortParam.concat(entitiesWithoutSortParam);
    }
  }


  onSort() {
    if (this.sortParam) {
      this.sortParam = undefined;
      this.router.navigate([], {
        queryParams: {
          'sort': null,
        },
        queryParamsHandling: 'merge'
      })
    }
  }

  public testMonthEnd() // for test monthly auto billing
  {
    this.toastService.loading('Abrechnung gestartet')
    this.pricingsService.testMonthEndForAll().subscribe(() => {
      this.toastService.success('Abrechnung erfolgreich', 0, true)
    }, error => {
      this.toastService.error('Abrechnung fehlgeschlagen', 0, true)
      console.error(error)
    });
  }


  matches(entry: CustomersTableEntry, term: string) {
    console.log(term);
    return entry.customerId?.toString().includes(term.toLowerCase()) ||
      entry.internalDescription?.toLowerCase().includes(term.toLowerCase()) ||
      entry.email?.toLowerCase().includes(term.toLowerCase()) ||
      entry.fullName?.toLowerCase().includes(term.toLowerCase()) ||
      entry.phone?.toLowerCase().includes(term.toLowerCase()) ||
      entry.company?.toLowerCase().includes(term.toLowerCase());
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }
}
